import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _RelationshipByOwner, _VehicleByAccount } from "../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../editor/AccountEditor";

interface Props {
    accountID: number;
}

export const VehicleByAccountNew = ({ accountID }: Props) => {

    const vehicle = useDataBean(_VehicleByAccount);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Type, setType] = useState<any>(null)
    const [modalentity, setModalentity] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modaltype, setModaltype] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        vehicle.instance.getVehicleByAccount(accountID).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        vehicle.setBean({
            IDAccount: accountID
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        vehicle.instance.deleteVoid(vehicle.bean.IDVehicle).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        vehicle.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
    const head = [
        { title: 'ID', property: 'IDVehicle', visible: true },
        { title: 'Propietario', property: 'OwnerName', visible: true },
        { title: 'Número de Placa', property: 'PlateNumber', visible: true },
        { title: 'Número de Etiqueta', property: 'TicketNumber', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Vehículos Asociados</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={vehicle.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor idAccount={vehicle.bean.IDOwner} label="Propietario" onChange={(e:any) => { vehicle.setBean({ ...vehicle.bean, 'IDOwner': e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Número de Placa</label>
                            <input type="text" name="PlateNumber" className="form-control" value={vehicle.bean.PlateNumber} onChange={(e: any) => { vehicle.setBean({ ...vehicle.bean, "PlateNumber": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Número de Etiqueta</label>
                            <input type="text" name="TicketNumber" className="form-control" value={vehicle.bean.TicketNumber} onChange={(e: any) => { vehicle.setBean({ ...vehicle.bean, "TicketNumber": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
                
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}